import gql from 'graphql-tag';
export default gql`
  query initGBGIdScan {
    initGBGIdScan {
      scanningToken
      investigationToken
      journeyDefinitionId
    }
  }
`;
